import { Box, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { AlarmClockIcon } from '../../assets/customIcons';
export var Timer = function (props) {
    var callback = props.callback, timing = props.timing;
    var _a = useState(0), seconds = _a[0], setSeconds = _a[1]; // 15 minutes in seconds
    var _b = useState(null), intervalId = _b[0], setIntervalId = _b[1];
    useEffect(function () {
        callback(seconds);
    }, [seconds]);
    useEffect(function () {
        setSeconds(timing);
    }, [timing]);
    useEffect(function () {
        if (intervalId) {
            clearInterval(intervalId);
        }
        var newIntervalId = setInterval(function () {
            setSeconds(function (prevCount) { return prevCount + 1; });
        }, 1000);
        setIntervalId(newIntervalId);
        // Cleanup function
        return function () { return clearInterval(newIntervalId); };
    }, [seconds]);
    var formatTime = function (seconds) {
        var _seconds = "".concat(seconds);
        if (_seconds[0] === '-') {
            var f = _seconds.replace('-', '');
            var minutes = Math.floor(f / 60);
            var remainingSeconds = f % 60;
            return "".concat(padZero(minutes), ":").concat(padZero(remainingSeconds));
        }
        else {
            var minutes = Math.floor(seconds / 60);
            var remainingSeconds = seconds % 60;
            return "".concat(padZero(minutes), ":").concat(padZero(remainingSeconds));
        }
    };
    var padZero = function (num) { return num < 10 ? "0".concat(num) : "".concat(num); };
    return /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            justifyContent: 'space-evenly',
            placeItems: 'center'
        }
    }, /*#__PURE__*/ React.createElement(AlarmClockIcon, {
        style: {
            color: "".concat(seconds)[0] === '-' ? '#CC7A00' : '#F5222D',
            height: '16px',
            width: '16px'
        }
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "subtitle2",
        color: "".concat(seconds)[0] === '-' ? '#CC7A00' : '#F5222D'
    }, "".concat(seconds)[0] === '-' ? '- ' : '+ ', formatTime(seconds), " min"));
};
